/* Dashboard.js */

import React, { useEffect, useCallback, useState } from 'react';
import { Row, Col, Container, Button, Card, CardBody, CardTitle, CardSubtitle, Tooltip, Alert } from 'reactstrap';
import { toast } from 'react-toastify';
import { useAuth } from '../../context/auth/AuthContext';
import Strings from '../../translations/Translations';
import PSO from '../../services/PSO';
import { Link } from 'react-router-dom';
// import AppBar1 from '../../components/commom/AppBar1';
import RemixHelper from '../../helpers/RemixHelper';
import Footer1 from '../../components/commom/Footer1';
import ModalShare from '../../components/modals/ModalShare';
import { IoArrowRedoOutline, IoPlay, IoInformationCircleOutline } from "react-icons/io5";
import { useHistory } from 'react-router-dom';
import Button1 from '../../components/buttons/Button1';
import { getRemixCover } from '../../helpers/GetRemixCover';
import AppBar2 from '../../components/commom/AppBar2/AppBar2';
import Cta1 from '../../components/misc/Cta1/Cta1';

const maxElementsPerRequest = 24;

export default function Dashboard() {
  const { authenticated, toggleLoading } = useAuth();
  const history = useHistory();

  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggleTooltip = () => setTooltipOpen(!tooltipOpen);

  const [modalShareOpen, setModalShareOpen] = useState(false);
  const [selectedRemix, setSelectedRemix] = useState();
  const [remixes, setRemixes] = useState();
  const [showLoadMore, setShowLoadMore] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const getMoreRemixes = useCallback(async (lastRemix = null) => {
    setIsLoading(true);
    let enableToRequest = false;
    const args = { un: authenticated.un, al: authenticated.al, username: authenticated.un, rnmax: maxElementsPerRequest };
    if (lastRemix.rid && lastRemix.rcdate) {
      enableToRequest = true;
      args.ridul = lastRemix.rid;
      args.rtsul = lastRemix.rcdate;
    }
    if (enableToRequest) {
      const response = await PSO.getRemixListByOwner(args);
      if (response && response.result === 'success' && response.its) {
        const currentRemixes = (remixes) ? remixes : [];
        setRemixes([...currentRemixes, ...response.its]);
        const isToShowLoadMore = (response.its.length === maxElementsPerRequest);
        setShowLoadMore(isToShowLoadMore);
      } else {
        toast.error(Strings('error_has_ocurred'));
      }
    }
    setIsLoading(false);
  }, [authenticated, remixes, setRemixes, setShowLoadMore]);

  const getRemixes = useCallback(async () => {
    toggleLoading(true);
    const args = { un: authenticated.un, al: authenticated.al, username: authenticated.un, rnmax: maxElementsPerRequest };
    const response = await PSO.getRemixListByOwner(args);
    if (response && response.result === 'success' && response.its) {
      setRemixes(response.its);
      const isToShowLoadMore = (response.its.length === maxElementsPerRequest);
      setShowLoadMore(isToShowLoadMore);
    } else {
      toast.error(Strings('error_has_ocurred'));
    }
    toggleLoading(false);
  }, [authenticated, setRemixes, toggleLoading, setShowLoadMore]);
  useEffect(() => { getRemixes(); }, [getRemixes]);

  return (
    <>
      <AppBar2 />

      <div className='pb-bg-2 dashboard-page'>
        <Container fluid className='pb-4'>
          <Cta1 />
        </Container>

        <Container fluid className='pb-4'>
          <Row className='pt-4 bg-white-dashboard pb-3'>
            <Col md={8} className='d-flex align-items-center'>
              <div>
                <h1 className='h3'>{Strings('my_pepblast_link_pages')}</h1>
                <p className='mb-0'>
                  <span className='mr-10px'>{Strings('pb_social_links_text_1')}</span>
                  <IoInformationCircleOutline id='tooltip-explain' />
                </p>
                <Tooltip
                  autohide={true}
                  flip={true}
                  isOpen={tooltipOpen}
                  target='tooltip-explain'
                  toggle={toggleTooltip}
                >
                  {Strings('pb_social_links_text_2')}
                </Tooltip>
              </div>
            </Col>
            <Col md={4} className='d-flex justify-content-end align-items-center'>
              <Link to='create' className='btn btn-primary btn-lg pb-btn-1'>
                {Strings('create_link_page')}
              </Link>
            </Col>
          </Row>

          <Row className='mt-5'>
            {remixes && remixes.length === 0 && (
              <Col sm={12} md={6}>
                <Alert color='secondary'>
                  {Strings('no_link_pages_description')}
                </Alert>
              </Col>
            )}
            {remixes && remixes.length > 0 && remixes.map((item) => (
              <Col xs={12} sm={12} md={4} lg={3} key={item.rid} className='mb-3'>
                <Card className='shadow'>
                  <img
                    src={getRemixCover(item)}
                    title={item.rti}
                    alt={item.rde}
                    className='cursor-pointer'
                    onClick={() => history.push(`edit/${item.rid}`)}
                  />
                  <CardBody>
                    <CardTitle tag="h5">
                      {item.rti}
                    </CardTitle>
                    <CardSubtitle
                      className="mb-2 text-muted"
                      tag="h6"
                    >
                      {item.rstag}
                    </CardSubtitle>
                    <div className='d-flex justify-content-between'>
                      <div>
                        <Link to={`edit/${item.rid}`} className='btn btn-secondary'>
                          {Strings('edit')}
                        </Link>
                      </div>
                      <div>
                        <Button className='mr-2-important' onClick={() => RemixHelper.openPopFansTinyPage(item.tid)} >
                          
                          <IoArrowRedoOutline size='1.2em' />
                        </Button>
                        <Button onClick={() => {
                          setSelectedRemix(item);
                          setModalShareOpen(true);
                        }}>
                          <IoPlay size='1.2em' />
                        </Button>
                        
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            ))}
            {showLoadMore && (
              <Col sm={12} className='d-flex justify-content-center mt-5'>
                <Button1
                  className='pb-btn-1'
                  size='lg'
                  onClick={() => {
                    const lastRemix = remixes[remixes.length - 1];
                    if (lastRemix && lastRemix.rid) { getMoreRemixes(lastRemix); }
                  }}
                  loading={isLoading}
                  disabled={isLoading}
                >
                  {Strings('load_more')}
                </Button1>
              </Col>
            )}
          </Row>

          <ModalShare open={modalShareOpen} setOpen={setModalShareOpen} remix={selectedRemix} />

        </Container>
      </div>

      <Footer1 />
    </>
  );
}
